module.exports = __webpack_public_path__ + "img/profile-bg.815874d8.jpg";